import * as PIXI from "pixi.js";
import Main from "../../../Main";
import HTPFirstPart from "../HTPFirstPart";

export default class HowToPlayText extends PIXI.Text {
  private Main = Main.getInstance();
  private HTPFirstPart = HTPFirstPart.getInstance();
  startScale = .2;
  constructor() {
    super();
    this.addText();
    this.addCoord();
    this.addAnim();
    this.addToCon();
  }
  addAnim() {
    this.scale.set(this.startScale);
  }
  addText() {
    this.text = "HOW TO PLAY"
    this.style = {
      fill: 0x5557a2,
      fontWeight: "600",
      fontSize: 50
    }
  }
  addCoord() {
    const dim = this.Main.getDim();
    this.anchor.set(.5, 0);
    this.x = dim.width / 2;
    this.y = dim.height / 2 - 250
  }
  addToCon() {
    this.HTPFirstPart.addChild(this);
  }
}